<template>

	<div id="app">
		<meta name="viewport"
			content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover">

		<router-view v-if="isRouterAlive"></router-view>


	</div>
</template>
<script>
	// @ is an alias to /src

	export default {
		name: 'App',
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		methods: {
			reload() {
				this.isRouterAlive = false
				this.$nextTick(function() {
					this.isRouterAlive = true
				})
			}
		},
		components: {

		}
	}
</script>
<style>
	/* 	body {
		padding: 0;
		margin: 0;
		width: 100%;
		height: 100%;
		min-height: 100%;
	} */


	#app {
		/* 	font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50; */
		background-color: #FFFFFF;
		width: 100%;
		height: 100%;
		min-height: 100%;

	}

	@media only screen and (max-width:680px) {
		.el-message-box__wrapper .loginshowcass {
			width: auto
		}


		.el-select-dropdown__list .el-select-dropdown__item {
			font-size: 11px !important;
		}
	}

	.el-scrollbar .el-scrollbar__bar {
		opacity: 1 !important;
	}
</style>
